import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { createBrowserHistory } from "history";
import { useSelector, useDispatch } from "react-redux";
import { updateExchangeSettingsDetails } from "../redux/slices";
import { exchangeSettingsActionTypes } from "../redux/utils";
import { useAPI } from "../hooks";
import { usePathNameContext, useAppContext } from "../contexts";
import { htmlColorArr, capitalizeFirstLetter } from "../Utilities";
import { arrayEquals } from "../Utilities/isArrayEqual";

/* 
 TODO:Update the variable Name
   Here 
   Color => Variant_1 or Options 1
   Size => Variant_2 or Options 2
   Others => Variant_3 or Options 3
*/

export const useExchangeFetch = () => {
  const [colorID, setColorID] = useState(0);
  const [selectedColor, setSelectedColor] = useState("");
  const [selectedSize, setSelectedSize] = useState("");
  const [selectedOthers, setSelectedOthers] = useState("");
  const [sizeID, setSizeID] = useState(0);
  const [otherID, setOtherID] = useState(0);
  const [productMainView, setProductMainView] = useState();
  const [productSideView, setProductSideView] = useState([]);
  const [colors, setColors] = useState([]);
  const [sizes, setSizes] = useState([]);
  const [variations, setVariations] = useState([]);
  const [itemToBeReturnedTags, setItemToBeReturnedTags] = useState("");
  const [isExLoader, setIsExLoader] = useState(false);
  const [otherOptions, setOtherOptions] = useState([]);
  const [others, setOthers] = useState([]);
  const [otherLabel, setOtherLabel] = useState("");
  const [noVariantAvailable, setNoVariantAvailable] = useState(false);
  const [isOutOfStock, setIsOutOfStock] = useState(false);
  const { pathURL } = usePathNameContext(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [outOfStock, setOutOfStock] = useState(false);
  const [disableContinueButton, setDisableContinueButton] = useState(false);
  const [changeCurrentPageFlag, setChangeCurrentPageFlag] = useState(0);
  const [prevNextFlag, setPrevNextFlag] = useState("");
  const [pageArr, setPageArr] = useState([]);
  const { isInternalServerError, setIsInternalServerError } = useAppContext();
  const history = createBrowserHistory();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const settingState = useSelector((state) => state.storeSettings);
  const productDetailsState = useSelector((state) => state.productDetails);
  const [isActiveSquare, setIsActiveSquare] = useState(false);
  const otherSettingsState = useSelector((state) => state.otherSettings);
  const { setIsBtnDisabled ,exchangeSearchInput,setexchangeSearchInput } = useAppContext();
  const selectedProductDetailsState = useSelector(
    (state) => state.selectedProductDetails
  );
  const exchangeSettingsState = useSelector((state) => state.exchangeSettings);
  const dataFrom = 0;
  const dataTo = exchangeSettingsState.paginateBy;
  const { EXCHANGE_ITEM_API, EXCHANGE_ITEM_PAGINATED_EXCHANGE_API } = useAPI();
  /* function get distinct value */
  const distinct = (value, index, self) => {
    return self.indexOf(value) === index;
  };

  useEffect(() => {
    return history.listen(() => {
      if (history.action === "POP") {
        dispatch(
          updateExchangeSettingsDetails({
            key: exchangeSettingsActionTypes.UPDATE_NEW_ITEM_NAME,
            value: null,
          })
        );

        dispatch(
          updateExchangeSettingsDetails({
            key: exchangeSettingsActionTypes.UPDATE_SELECTED_PRODUCT_NAME,
            value: null,
          })
        );
      }
    });
  }, [history, navigate]);

  useEffect(() => {
    (async () => {
      try {
        setIsExLoader(
          true
        ); /* set the loader true spinner will start in the screen */
        setIsBtnDisabled(true);
        const VariantID = selectedProductDetailsState.variantID;
        const productID = selectedProductDetailsState.productID;

        const response = await fetch(EXCHANGE_ITEM_API, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            shop: settingState.storeUniqueID,
            variant_id: VariantID,
            product_id: productID,
            customer_email: productDetailsState.customerEmail,
            test_mode: productDetailsState.testMode,
            order_id: productDetailsState.recentOrderID,
            line_item_id: selectedProductDetailsState.lineItemID,
            line_item_location_id: selectedProductDetailsState.lineItemLocationId,
            order_country: selectedProductDetailsState.countryCode,
            quantity: parseInt(selectedProductDetailsState.selectedQuantity),
            access_code: otherSettingsState.accessCode,
            currency: productDetailsState.sessionCurrency,
            search_product_name : exchangeSearchInput,
          }),
        });

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();

        if (data) {
          if (!exchangeSettingsState.newItemName) {
            dispatch(
              updateExchangeSettingsDetails({
                key: exchangeSettingsActionTypes.UPDATE_NEW_ITEM_NAME,
                value: data.data?.item_to_be_returned.name,
              })
            );
          }

          dispatch(
            updateExchangeSettingsDetails({
              key: exchangeSettingsActionTypes.UPDATE_SELECTED_PRODUCT_NAME,
              value: data.data?.item_to_be_returned.name,
            })
          );

          dispatch(
            updateExchangeSettingsDetails({
              key: exchangeSettingsActionTypes.UPDATE_IS_ALLOW_ALL_PRODUCTS,
              value: data.data?.allow_all_products,
            })
          );

          dispatch(
            updateExchangeSettingsDetails({
              key: exchangeSettingsActionTypes.UPDATE_ALLOW_OUT_OF_STOCK,
              value: data.data?.allow_out_of_stock,
            })
          );

          dispatch(
            updateExchangeSettingsDetails({
              key: exchangeSettingsActionTypes.UPDATE_ORDER_EXCHANGE_INFO,
              value: data,
            })
          );

          dispatch(
            updateExchangeSettingsDetails({
              key: exchangeSettingsActionTypes.UPDATE_AVAILABLE_CREDITS_CURRENCY,
              value: data.data?.currency,
            })
          );

          dispatch(
            updateExchangeSettingsDetails({
              key: exchangeSettingsActionTypes.UPDATE_AVAILABLE_CREDITS,
              value: data.data?.available_credit,
            })
          );

          dispatch(
            updateExchangeSettingsDetails({
              key: exchangeSettingsActionTypes.UPDATE_BONUS,
              value: data.data?.bonus,
            })
          );

          /* it will set the other tag to default title*/
          if (
            data.data?.variant_options.length === 1 &&
            data.data?.variant_options[0]?.name === "Title" &&
            data.data?.variant_options[0]?.values.length === 1 &&
            data.data?.variant_options[0]?.values[0] ===
              "Default Title"
          ) {
            setNoVariantAvailable(true);
          }

          /* initialize the variation variable */
          let variation_color =
              data?.data?.variant_options[0]?.values,
            variation_size = [],
            variation_other_tag = [];

          /* filtering distinct variation like color, size and other tag */
          data.data?.exchange_options?.variations?.forEach((item) => {
            // variation_color = [
            //   ...variation_color,
            //   item.color.toLowerCase(),
            // ].filter(distinct);
            variation_size = [...variation_size, item.size].filter(distinct);
            variation_other_tag = [
              ...variation_other_tag,
              item.other_tag,
            ].filter(distinct);
          });

          /* setting variation like color, size and other tag and Remove 
          null or empty value from the array variable   */

          // setSizes(variation_size.filter((el) => el != null && el !== ""));
          // setColors(variation_color.filter((el) => el != null && el !== ""));
          // setOthers(
          //   variation_other_tag.filter((el) => el != null && el !== "")
          // );

          variation_color.map((item) => {
            let tempArr = htmlColorArr();
            if (!tempArr?.includes(item?.toLowerCase())) {
              setIsActiveSquare(true);
            }
          });

          /*setting Other Tag label */
          data.data?.variant_options.forEach((item) => {
            if (
              item.name !== "Size" &&
              item.name !== "Color" &&
              item.name !== "Title"
            ) {
              setOtherLabel(item.name);
            }
          });

          setVariations(data.data?.exchange_options?.variations);
          setOtherOptions(
            data.data?.exchange_options?.other_options
          );

          /* Setting Default selected value for color, size and other tag */
          // setSelectedColor(
          //   response.data.data?.exchange_options?.variations[0]?.color
          // );
          // setSelectedSize(
          //   response.data.data?.exchange_options?.variations[0]?.size
          // );
          // setSelectedOthers(
          //   response.data.data?.exchange_options?.variations[0]?.other_tag
          // );

          setSelectedColor(data?.data?.variant_options[0]?.values[0]);
          setSelectedSize(data?.data?.variant_options[1]?.values[0]);
          setSelectedOthers(
            data?.data?.variant_options[2]?.values[0]
          );
          setProductMainView(
            data.data?.exchange_options?.variations[0]?.images[0]
          );

          setProductSideView(
            data.data?.exchange_options?.variations[0]?.images
          );

          dispatch(
            updateExchangeSettingsDetails({
              key: exchangeSettingsActionTypes.UPDATE_SELECTED_COLOR,
              value:
                data.data?.exchange_options?.variations[0]?.tags[0],
            })
          );

          dispatch(
            updateExchangeSettingsDetails({
              key: exchangeSettingsActionTypes.UPDATE_SELECTED_SIZE,
              value:
                data.data?.exchange_options?.variations[0]?.tags[1],
            })
          );

          dispatch(
            updateExchangeSettingsDetails({
              key: exchangeSettingsActionTypes.UPDATE_SELECTED_OTHER,
              value:
                data.data?.exchange_options?.variations[0]?.tags[2],
            })
          );

          dispatch(
            updateExchangeSettingsDetails({
              key: exchangeSettingsActionTypes.UPDATE_NEXT_URL,
              value: data.data?.exchange_options?.next_url,
            })
          );

          dispatch(
            updateExchangeSettingsDetails({
              key: exchangeSettingsActionTypes.UPDATE_PREV_URL,
              value: data.data?.exchange_options?.prev_url,
            })
          );

          dispatch(
            updateExchangeSettingsDetails({
              key: exchangeSettingsActionTypes.UPDATE_OTHER_OPTIONS_COUNT,
              value: data.data?.exchange_options?.other_options_count,
            })
          );

          dispatch(
            updateExchangeSettingsDetails({
              key: exchangeSettingsActionTypes.UPDATE_PAGINATED_BY,
              value: data.data?.exchange_options?.paginate_by,
            })
          );

          if (
            exchangeSettingsState.isCustomItem ||
            !data?.exchange_options?.variations[0]?.images[0]
          ) {
            setProductMainView(
              data.data?.item_to_be_returned?.img_url
            );
          } else {
            setProductMainView(
              data.data?.exchange_options?.variations[0]?.images[0]
            );
          }

          setProductSideView(
            data.data?.exchange_options?.variations[0]?.images
          );

          let variant_tags = data.data?.item_to_be_returned?.tags;
          let variant_labels = [];
          data.data.variant_options.forEach((variant) => {
            variant_labels = [
              ...variant_labels,
              variant.name ? variant.name + ":" : "",
            ];
          });
          let item_tags_with_value = "";

          variant_tags.map((item, index) => {
            return setItemToBeReturnedTags(
              (prev) => prev + `${variant_labels[index]} ${item},`
            );
          });

          variant_tags.forEach((item, index) => {
            item_tags_with_value =
              item_tags_with_value + `${variant_labels[index]} ${item},`;
          });

          dispatch(
            updateExchangeSettingsDetails({
              key: exchangeSettingsActionTypes.UPDATE_ITEM_TO_BE_RETURNED,
              value: item_tags_with_value,
            })
          );

          if (!exchangeSettingsState.isExchangeOther) {
            dispatch(
              updateExchangeSettingsDetails({
                key: exchangeSettingsActionTypes.UPDATE_VARIANTS_LABELS,
                value: variant_labels,
              })
            );
          }

          if (!data.data?.item_to_be_returned?.tags[1]) {
            dispatch(
              updateExchangeSettingsDetails({
                key: exchangeSettingsActionTypes.UPDATE_SELECTED_ITEM_COLOR,
                value: false,
              })
            );
          } else {
            dispatch(
              updateExchangeSettingsDetails({
                key: exchangeSettingsActionTypes.UPDATE_SELECTED_ITEM_COLOR,
                value: data.data?.item_to_be_returned?.tags[1],
              })
            );
          }
          if (!data.data?.item_to_be_returned?.tags[2]) {
            dispatch(
              updateExchangeSettingsDetails({
                key: exchangeSettingsActionTypes.UPDATE_SELECTED_ITEM_OTHER_TAG,
                value: false,
              })
            );
          } else {
            dispatch(
              updateExchangeSettingsDetails({
                key: exchangeSettingsActionTypes.UPDATE_SELECTED_ITEM_OTHER_TAG,
                value: data.data?.item_to_be_returned?.tags[2],
              })
            );
          }

          if (!data.data?.item_to_be_returned?.tags[0]) {
            dispatch(
              updateExchangeSettingsDetails({
                key: exchangeSettingsActionTypes.UPDATE_SELECTED_ITEM_SIZE,
                value: false,
              })
            );
          } else {
            dispatch(
              updateExchangeSettingsDetails({
                key: exchangeSettingsActionTypes.UPDATE_SELECTED_ITEM_SIZE,
                value: data.data?.item_to_be_returned?.tags[0],
              })
            );
          }

          //Redirect to SEE ALL ITEMS screen if the item is custom
          if (data.data?.item_to_be_returned?.is_custom_item) {
            dispatch(
              updateExchangeSettingsDetails({
                key: exchangeSettingsActionTypes.UPDATE_IS_CUSTOM_ITEM,
                value: data.data?.item_to_be_returned?.is_custom_item,
              })
            );
          } else {
            dispatch(
              updateExchangeSettingsDetails({
                key: exchangeSettingsActionTypes.UPDATE_IS_CUSTOM_ITEM,
                value: false,
              })
            );
          }

          setColors(data?.data?.variant_options[0]?.values);
          setSizes(data?.data?.variant_options[1]?.values);
          setOthers(data?.data?.variant_options[2]?.values);
          setIsBtnDisabled(false);
          setIsExLoader(false);
        }
      } catch (error) {
        if (error?.response?.status === 500) {
          setIsExLoader(false);
          setIsInternalServerError(true);
        }
        setIsBtnDisabled(false);
      }
    })();
  }, [exchangeSettingsState.isCustomItem, exchangeSearchInput]);

  /*Page Array setup */

  useEffect(() => {
    if (exchangeSettingsState.otherOptionsCount <= dataTo) {
      setPageArr([1]);
    } else {
      let quotient = parseInt(exchangeSettingsState.otherOptionsCount / dataTo);
      let remainder = parseInt(
        exchangeSettingsState.otherOptionsCount % dataTo
      );

      if (remainder > 0 && remainder <= dataTo) {
        remainder = 1;
      }

      let numberOfPages = parseInt(quotient, 10) + parseInt(remainder, 10);

      let tempPageArr = [];
      for (let i = 1; i <= numberOfPages; i++) {
        tempPageArr = [...tempPageArr, i];
      }

      setPageArr(tempPageArr);
    }
  }, [dataTo, exchangeSettingsState.otherOptionsCount]);

  useEffect(() => {
    (async () => {
      try {
        if (changeCurrentPageFlag >= 1) {
          setIsExLoader(true);
          setIsBtnDisabled(true);
          const StoreUniqueID = settingState.storeUniqueID;
          const response = await fetch(EXCHANGE_ITEM_PAGINATED_EXCHANGE_API, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              shop: StoreUniqueID,
              next_url:
                prevNextFlag === "prev"
                  ? exchangeSettingsState.prevURL
                  : exchangeSettingsState.nextURL,
              line_item_id: selectedProductDetailsState.lineItemID,
              line_item_location_id: selectedProductDetailsState.lineItemLocationID,
              order_country: selectedProductDetailsState.countryCode,
              quantity: parseInt(selectedProductDetailsState.selectedQuantity),
              variant_id: selectedProductDetailsState.variantID,
              order_id: productDetailsState.recentOrderID,
              product_id: selectedProductDetailsState.productID,
              currency: productDetailsState.sessionCurrency,
              search_product_name : exchangeSearchInput,
            }),
          });

          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }

          const data = await response.json();

          setOtherOptions(data.data?.other_options);

          dispatch(
            updateExchangeSettingsDetails({
              key: exchangeSettingsActionTypes.UPDATE_PREV_URL,
              value: data.data.prev_url,
            })
          );

          dispatch(
            updateExchangeSettingsDetails({
              key: exchangeSettingsActionTypes.UPDATE_NEXT_URL,
              value: data.data.next_url,
            })
          );
          setIsExLoader(false);
          setIsBtnDisabled(false);
        }
      } catch (error) {
        if (error?.response?.status === 500) {
          setIsInternalServerError(true);
        }
        setIsBtnDisabled(false);
      }
    })();
  }, [changeCurrentPageFlag, navigate]);

  useEffect(() => {
    if (pathURL.toLowerCase() === "/exchange") {
      const selectedItemTags = [
        capitalizeFirstLetter(selectedColor),
        selectedSize,
        selectedOthers,
      ];
      const filterSelectedItemTags = selectedItemTags.filter((a) => a);

      const filteredItem = variations.find((item) => {
        let itemTagsArr = [...item.tags];
        let isTagMatch = arrayEquals(itemTagsArr, filterSelectedItemTags);
        if (isTagMatch) {
          return true;
        }
      });

      if (!exchangeSettingsState.isExchangeOther)
        dispatch(
          updateExchangeSettingsDetails({
            key: exchangeSettingsActionTypes.UPDATE_NEW_ITEM_VARIATIONS,
            value: filteredItem,
          })
        );

      const updateSelectedVariantItemData = (item) => {
        dispatch(
          updateExchangeSettingsDetails({
            key: exchangeSettingsActionTypes.UPDATE_NEW_ITEM_PRICE,
            value: item.price,
          })
        );

        dispatch(
          updateExchangeSettingsDetails({
            key: exchangeSettingsActionTypes.UPDATE_NEW_ITEM_PRICE_CURRENCY,
            value: item.currency,
          })
        );

        dispatch(
          updateExchangeSettingsDetails({
            key: exchangeSettingsActionTypes.UPDATE_NEW_ITEM_IMAGE,
            value: item.img_url,
          })
        );

        dispatch(
          updateExchangeSettingsDetails({
            key: exchangeSettingsActionTypes.UPDATE_NEW_ITEM_SIZE,
            value: item.size,
          })
        );

        dispatch(
          updateExchangeSettingsDetails({
            key: exchangeSettingsActionTypes.UPDATE_NEW_ITEM_COLOR,
            value: item.color,
          })
        );

        dispatch(
          updateExchangeSettingsDetails({
            key: exchangeSettingsActionTypes.UPDATE_NEW_ITEM_OTHER_TAG,
            value: item.other_tag,
          })
        );

        // dispatch(
        //   updateExchangeSettingsDetails({
        //     key: exchangeSettingsActionTypes.UPDATE_NEW_ITEM_NAME,
        //     value: item.name,
        //   })
        // );
        dispatch(
          updateExchangeSettingsDetails({
            key: exchangeSettingsActionTypes.UPDATE_EXCHANGE_VARIANT_ID,
            value: item.variant_id,
          })
        );

        dispatch(
          updateExchangeSettingsDetails({
            key: exchangeSettingsActionTypes.UPDATE_EXCHANGE_PRODUCT_ID,
            value: item.product_id,
          })
        );

        setProductSideView(item.images);
        // setProductMainView(item.img_url);
      };

      // If custom item or can't allow out of stock orders => Disable continue button
      if (
        exchangeSettingsState.isCustomItem ||
        !exchangeSettingsState.allowOutOfStock
      ) {
        setDisableContinueButton(true);
      } else {
        setDisableContinueButton(false);
      }

      // If Selected Size, Color and Other Tag variant exists
      // If not exist, It automatically re-rendered with size and color that exists
      if (filteredItem) {
        updateSelectedVariantItemData(filteredItem);

        if (
          filteredItem.quantity <= 0 &&
          !exchangeSettingsState.allowOutOfStock
        ) {
          setDisableContinueButton(true);
        } else setDisableContinueButton(false);
      }

      /* setting up size and other variants when user click on the variants */
      let variation_size = [],
        variation_other_tag = [];

      variations?.map((item) => {
        if (item.color?.toLowerCase() === selectedColor?.toLowerCase()) {
          return (variation_size = [...variation_size, item.size].filter(
            distinct
          ));
        }
      });

      variations?.map((item) => {
        if (
          item.color?.toLowerCase() === selectedColor?.toLowerCase() &&
          item.size === selectedSize
        ) {
          return (variation_other_tag = [
            ...variation_other_tag,
            item.other_tag,
          ].filter(distinct));
        }
      });

      if (variation_other_tag.length === 0) {
        // setSelectedSize((prev) => {
        //   return (prev = variation_size[0]);
        // });

        dispatch(
          updateExchangeSettingsDetails({
            key: exchangeSettingsActionTypes.UPDATE_NEW_ITEM_SIZE,
            value: variation_size[0],
          })
        );

        setSizeID((prev) => {
          return (prev = 0);
        });

        setOtherID(0);

        // setSelectedOthers((prev) => {
        //   return (prev = variation_other_tag[0]);
        // });
      }

      if (!selectedOthers) {
        dispatch(
          updateExchangeSettingsDetails({
            key: exchangeSettingsActionTypes.UPDATE_NEW_ITEM_OTHER_TAG,
            value: variation_other_tag[0],
          })
        );
      } else {
        dispatch(
          updateExchangeSettingsDetails({
            key: exchangeSettingsActionTypes.UPDATE_NEW_ITEM_OTHER_TAG,
            value: selectedOthers,
          })
        );
      }

      dispatch(
        updateExchangeSettingsDetails({
          key: exchangeSettingsActionTypes.UPDATE_NEW_ITEM_COLOR,
          value: selectedColor,
        })
      );

      dispatch(
        updateExchangeSettingsDetails({
          key: exchangeSettingsActionTypes.UPDATE_NEW_ITEM_SIZE,
          value: selectedSize,
        })
      );
    }
  }, [
    selectedColor,
    selectedSize,
    variations,
    selectedOthers,
    pathURL,
    exchangeSettingsState.isCustomItem,
    exchangeSettingsState.allowOutOfStock,
    dispatch,
  ]);

  return {
    colors,
    setColorID,
    setSelectedColor,
    colorID,
    sizes,
    setSizeID,
    setSelectedSize,
    sizeID,
    productSideView,
    productMainView,
    itemToBeReturnedTags,
    isExLoader,
    setIsExLoader,
    otherOptions,
    others,
    setOthers,
    otherLabel,
    noVariantAvailable,
    selectedOthers,
    setSelectedOthers,
    otherID,
    setOtherID,
    setProductMainView,
    setProductSideView,
    setSizes,
    setColors,
    outOfStock,
    setChangeCurrentPageFlag,
    setPrevNextFlag,
    isOutOfStock,
    disableContinueButton,
    dataFrom,
    dataTo,
    currentPage,
    pageArr,
    setCurrentPage,
    isActiveSquare,
    isInternalServerError,
  };
};
